// Source
// https://github.com/bvaughn/react-error-boundary/blob/master/src/index.tsx
import React from "react"
import { ErrorBoundary } from "../components/react-error-boundary";
import './error-global-boundary.scss';
import InternalServerError from "./internal-server-error";

export const ErrorFallback = ({ error }) => {
  return (
      <div className="error-boundary">
        <InternalServerError error={error}/>
      </div>
  )
}

export const ErrorGlobalBoundary = (props) => {

    return (
    <ErrorBoundary FallbackComponent={ErrorFallback}
    >
      {props.children}
    </ErrorBoundary>
    )
}
